import { Component, ElementRef, Input, OnInit, Output, ViewChild } from '@angular/core';
import { ButtonModule } from 'primeng/button';
import { TableModule } from 'primeng/table';
import { ProjectService } from '../../../../services/project.service';
import { InputTextareaModule } from 'primeng/inputtextarea';
import { InputTextModule } from 'primeng/inputtext';
import { FormGroup, FormsModule } from '@angular/forms';
import { IProject, ISubmission, Icriteria } from '../../../../interfaces/models/project.model';
import { CommonModule } from '@angular/common';
import { ToastrService } from 'ngx-toastr';
import { SuccessModalComponent } from '../../../../shared/components/success-modal/success-modal.component';
import { NotificationService } from '../../../../services/notification.service';
import { DirectionService } from '../../../../services/direction.service';
import { TranslateModule } from '@ngx-translate/core';
import { DropdownModule } from 'primeng/dropdown';


@Component({
  selector: 'app-project-review',
  standalone: true,
  imports: [TableModule,
    ButtonModule,
    FormsModule,
    CommonModule,
    InputTextareaModule,
    InputTextModule,
    FormsModule,
    SuccessModalComponent,
    TranslateModule,
    DropdownModule
  ],
  templateUrl: './project-review.component.html',
  styleUrl: './project-review.component.scss'
})
export class ProjectAssessmentComponent implements OnInit {
  @ViewChild('reasonForm') reasonForm!: FormGroup;
  @ViewChild('reasons_ref_native') reasons_ref_native!: ElementRef<HTMLInputElement>;
  @Input() strategyId = 0
  @Input() projectId = 0
  @Input() project !: IProject;
  @Input() submissionId = 0;
  isSubmitted = false;
  isSuccessModalVisible = false;
  mainsubmission: ISubmission | null = null;
  criterias: Icriteria[] = [];
  finalScore = 0;
  reasons = ""
  dir!: 'rtl' | 'ltr';
  locale!: "ar" | "en";
  
  // Score options from 0 to 10
  scoreOptions = [
    { label: '0', value: 0 },
    { label: '1', value: 1 },
    { label: '2', value: 2 },
    { label: '3', value: 3 },
    { label: '4', value: 4 },
    { label: '5', value: 5 },
    { label: '6', value: 6 },
    { label: '7', value: 7 },
    { label: '8', value: 8 },
    { label: '9', value: 9 },
    { label: '10', value: 10 }
  ];
  
  // Expose state for parent component
  get canSubmitReview(): boolean {
    return !this.mainsubmission?.is_assessed;
  }
  
  constructor(
    private projectService: ProjectService,
    private toastr: ToastrService,
    private notificationService: NotificationService,
    private directionService: DirectionService

  ) {
  }


  ngOnInit(): void {

    this.directionService.direction$.subscribe((dir) => {
      this.dir = dir;
      this.locale = dir == "rtl" ? "ar" : "en";
    })

    if (this.submissionId > 0) {
      this.projectService.listSubmissionCriterias(this.strategyId, this.projectId, this.submissionId).subscribe((response: any) => {
        this.criterias = response?.data?.criterias || [];
      });
    }

    this.projectService.ListSubmission(this.strategyId, this.projectId)
      .subscribe((response: any) => {
        const subs = response?.data?.submissions || [];
        this.mainsubmission = subs.find((submission: ISubmission) => submission?.is_main) || null;
        // this.criterias = this.mainsubmission.criterias;
        // this.reCalculate();
      })
  }

  reCalculate() {
    const list = Array.isArray(this.criterias) ? this.criterias : [];
    this.finalScore = list.reduce((prv, curr) => prv + +(curr?.score || 0), 0);
  }

  updateSubmission() {

    this.isSubmitted = true;
    if (this.reasonForm.valid) {
      this.projectService.UpdateSubmission(this.strategyId, this.projectId, this.submissionId, { "criterias": this.criterias, "reasons": this.reasons }).subscribe((response) => {
        this.isSuccessModalVisible = true;
        this.isSubmitted = false;
        this.notificationService.pushProjectSubmissionResponse(
          +this.strategyId,
          +(this.project?.id || 0),
          +(this.project?.in_charge_id || 0),
          this.locale
        );
        setTimeout(() => {
          this.isSuccessModalVisible = false;
        }, 3000)
      }, (err) => {
        this.toastr.error(err['error']['error']['message']);
      })
    } else {
      this.toastr.error(' يرجي كتابة الاسباب ', 'فشل')
      this.reasons_ref_native.nativeElement.scrollIntoView({ behavior: "smooth", block: "end", inline: 'center' });
      setTimeout(() => {
        this.reasons_ref_native.nativeElement.focus();
      }, 700)
    }

  }
}